module.exports = __webpack_public_path__ + "img/it.f04de15f.svg";